import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-width: 400px;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;

	@media (max-width: 700px) {
		min-width: 50vw;
	}
`;
